module.exports = __webpack_public_path__ + "img/Group 1.d11ce36a.png";